import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Enso } from "@/components/Layout";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams((location.hash || "").replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    googleSession(sessionId)
      .then((user) => {
        if (user.role === "seeker" && !user.city_id) {
          navigate("/welcome", { replace: true });
          return;
        }
        navigate(user.role === "admin" ? "/admin" : user.role === "practitioner" ? "/dashboard" : "/", { replace: true });
      })
      .catch(() => {
        toast.error("Google sign-in failed. Please try again.");
        navigate("/login", { replace: true });
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-4" data-testid="auth-callback-loading">
      <Enso size={44} />
      <p className="text-muted-foreground text-sm">Signing you in…</p>
    </div>
  );
}
